import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import api from "../lib/api";

export default function LogPage() {
  const { storeId } = useOutletContext();
  const [logs, setLogs] = useState(null);

  useEffect(() => {
    setLogs(null);
    api.get(`/log?store_id=${storeId}&limit=300`).then((r) => setLogs(r.data)).catch(() => {});
  }, [storeId]);

  return (
    <div data-testid="log-page">
      <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900 mb-4">Log modifiche</h1>
      <div className="bg-white border border-slate-200 rounded-lg overflow-x-auto">
        <table data-testid="log-table" className="w-full text-sm">
          <thead>
            <tr className="bg-slate-100/80 text-left">
              {["Quando", "Utente", "Ordine", "Campo", "Valore prima", "Valore dopo"].map((h) => (
                <th key={h} className="px-3 py-2.5 text-xs font-bold uppercase tracking-wider text-slate-600">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(logs || []).map((l) => (
              <tr key={l.id} className="border-t border-slate-100">
                <td className="px-3 py-2 font-mono text-xs whitespace-nowrap">{new Date(l.timestamp).toLocaleString("it-IT")}</td>
                <td className="px-3 py-2 text-xs">{l.utente}</td>
                <td className="px-3 py-2 font-mono text-xs">{l.id_ordine_esterno || "—"}</td>
                <td className="px-3 py-2 font-medium">{l.campo}</td>
                <td className="px-3 py-2 font-mono text-xs max-w-[220px] truncate" title={l.valore_prima}>{l.valore_prima ?? "—"}</td>
                <td className="px-3 py-2 font-mono text-xs max-w-[220px] truncate" title={l.valore_dopo}>{l.valore_dopo ?? "—"}</td>
              </tr>
            ))}
            {logs && logs.length === 0 && <tr><td colSpan={6} className="px-4 py-8 text-center text-slate-400">Nessuna modifica registrata.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
